import React, { useState } from "react";
import ModuleRatingsTable from "./Tables/ModuleRatingsTable";
import StudentRatingsTable from "./Tables/StudentRatingsTable";
import { GetCourseGrades } from "../../actions/adminQueries";
import { FormattedMessage } from "react-intl";
import { Card, CardBody, CardSubtitle, Button } from "reactstrap";
import { PacmanLoader } from "react-spinners";

export default function ModuleRatings({ table }) {
  const [showingForAllTime, setShowingForAllTime] = useState(false);
  const courseGrades = GetCourseGrades(!showingForAllTime);

  const windowToggleCard = () => {
    return (
      <Card>
        <CardBody>
          <CardSubtitle>
            <FormattedMessage
              id={
                showingForAllTime
                  ? "CurrentlyShowingAllResults"
                  : "CurrentlyOnlyDataForTheLastSixMonthsIsShownPressToShowMore"
              }
            />
          </CardSubtitle>
          <Button
            outline
            size="sm"
            color="primary"
            onClick={() => setShowingForAllTime(!showingForAllTime)}
          >
            <FormattedMessage
              id={showingForAllTime ? "ShowLastSixMonths" : "ShowAllResults"}
            />
          </Button>
        </CardBody>
      </Card>
    );
  };

  if (courseGrades.isPending) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  if (table === "moduleGrade") {
    return (
      <>
        {windowToggleCard()}
        <ModuleRatingsTable
          ratingsResponse={courseGrades.data?.moduleRatings ?? []}
          avgRating={courseGrades.data?.gradeAverage}
          totRatings={courseGrades.data?.totalNumberOfGrades}
        />
      </>
    );
  } else if (table === "studGrade") {
    return (
      <>
        {windowToggleCard()}
        <StudentRatingsTable comments={courseGrades.data?.studentRatings ?? []} />
      </>
    );
  }
}
